import { Component, OnInit, ViewChild } from '@angular/core';
import { PageInfoService, PageLink } from '@metronic/layout';
import { BaseTableService } from '@shared/base/base-table-service.service';
import { TableColumn } from '@shared/interface/table.interface';
import { MatSort } from '@angular/material/sort';
import { BaseDatasource } from '@shared/base/base.datasource';
import { IListProducts } from '../Products.interface';
import { API } from '@config/constants/api.constant';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { ActivatedRoute, Router } from '@angular/router';
import { UrlUtilsService } from '@utils/url-utils.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { InputSelectInterface } from '@shared/components/form/input-select/input-select.interface';
import { MultipleSelectChipComponent } from '@shared/components/multiple-select-chip/multiple-select-chip.component';
import { UtilitiesService } from '@services/utilities.service';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { FilterService } from '@services/filter.service';
import { ProductBrandService } from '@services/product-brand.service';

@Component({
  selector: 'app-products-list',
  templateUrl: './products-list.component.html',
  styleUrls: ['./products-list.component.scss'],
})
export class ProductsListComponent implements OnInit {
  @ViewChild('inputSelectMatChips') inputSelectMatChips: MultipleSelectChipComponent;
  @ViewChild(MatSort, { static: false }) matSort: MatSort;
  tableColumns: TableColumn[];
  privilageDetailProductCatalog: boolean;
  displayedColumns: string[];
  productsList: IListProducts[];
  baseDatasource: BaseDatasource<IListProducts>;
  string_filter: string;
  isOpenFilter: boolean;
  isActiveFilter: boolean;
  filterForm: FormGroup;
  checkActive: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  pestisidaList: InputSelectInterface[];
  plantTypeList: InputSelectInterface[];
  behaviorSubjectPlantTypeList: BehaviorSubject<InputSelectInterface[]> = new BehaviorSubject<InputSelectInterface[]>([]);
  plantTypeValue: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  links: Array<PageLink> = [
    { title: 'Product Catalog', path: '', isActive: false },
    { title: '', path: '', isActive: false, isSeparator: true },
    { title: 'Product List', path: '', isActive: true },
  ];
  tableColumn = ['id', 'status', 'pant_type_name', 'unit_price'];
  STRING_CONSTANTS = STRING_CONSTANTS;
  iconNone = STRING_CONSTANTS.ICON.IC_PACKAGE_NONE;
  baseTable: BaseTableService<IListProducts> = this.base;

  constructor(
    private pageInfoService: PageInfoService,
    private base: BaseTableService<IListProducts>,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private urlParamService: UrlUtilsService,
    private formBuilder: FormBuilder,
    private utilities: UtilitiesService,
    private rolePrivilegeService: RolePrivilegeService,
    public filterService: FilterService,
    private productBrandService: ProductBrandService
  ) {}

  ngOnInit(): void {
    this.baseTable.responseDatabase.subscribe((response) => (this.baseDatasource = response));
    this.privilageDetailProductCatalog = this.rolePrivilegeService.checkPrivilege('PRODUCT_CATALOG', 'LIST_PRODUCT_PUBLISHED', 'LIST_PRODUCT_PUBLISHED');
    this.setTableData();
    this.getDataFilter();
    this.initFilter();
    this.queryHandler();
    this.initPageInfo();
  }

  getDataFilter() {
    this.getListPestisida();
    this.getListPlantType();
  }

  getListPlantType() {
    this.productBrandService.getListPlantType().subscribe((resp) => {
      if (!resp) return;
      this.plantTypeList = this.productBrandService.mapInputSelectPlantType(resp.data);
      this.behaviorSubjectPlantTypeList.next(this.plantTypeList);
    });
  }

  getListPestisida() {
    this.productBrandService.getListPestisida().subscribe((resp) => {
      if (!resp) return;
      this.pestisidaList = this.productBrandService.mapInputSelectPesticide(resp.data);
    });
  }

  initPageInfo() {
    this.baseDatasource.tableSubject.subscribe((data) => {
      if (data) {
        this.productsList = data;
        this.pageInfoService.updateTitle('Product List');
        this.pageInfoService.updateBreadcrumbs(this.links);
      }
    });
  }

  updateCount() {
    this.baseDatasource.totalItem$.subscribe((data) => {
      if (data) {
        this.pageInfoService.updateTitle(`Product List (` + data + `)`);
      } else {
        this.pageInfoService.updateTitle(`Product List (0)`);
      }
    });
  }

  queryHandler() {
    this.activeRoute.queryParams.subscribe((data) => {
      this.string_filter = data.string_filter;
      this.filterForm.controls['plant_type'].setValue(data.plant_type);
      this.filterForm.controls['pesticide_type'].setValue(data.pesticide_type);
      this.isActiveFilter = !!(data.plant_type || data.pesticide_type);
      const param = this.urlParamService.sliceQueryParams();
      this.baseTable.loadDataTable(API.LIST_BRAND, param ? param : '');
      this.updateCount();
    });
  }

  changePageEvent($event: BaseDatasource<any>) {
    this.filterService.changePageEvent($event, this.string_filter ?? '');
  }

  setTableData() {
    this.tableColumns = [
      { title: 'NAMA PRODUK', key: 'name' },
      { title: 'JENIS PESTISIDA', key: 'pesticide_type' },
      { title: 'JENIS TANAMAN', key: 'plant_type' },
      { title: 'JUMLAH VARIANT', key: 'variant' },
      { title: 'STATUS', key: 'status' },
    ];
    this.tableColumns = this.utilities.privilegeTableColumns(this.privilageDetailProductCatalog, this.tableColumns);
    this.displayedColumns = this.tableColumns.map((head) => head.key);
    this.baseDatasource = new BaseDatasource();
    if (this.productsList) {
      this.baseDatasource.tableSubject.next(this.productsList);
    }
  }

  initFilter() {
    this.filterForm = this.formBuilder.group({
      pesticide_type: [''],
      plant_type: [''],
    });
  }

  handleSubmitFilter = () => {
    this.isActiveFilter = true;
    this.isOpenFilter = false;
    const plantTypeValueFilter = this.plantTypeValue.value.join(',');

    this.checkActive.next(!this.checkActive.value);
    const _extras = {
      queryParams: {
        pesticide_type: this.filterForm.value.pesticide_type,
        plant_type: plantTypeValueFilter ? plantTypeValueFilter : undefined,
      },
    };
    this.filterService.submitFilter(this.filterForm, _extras);
  };

  handleResetFilter = () => {
    this.isActiveFilter = false;
    this.isOpenFilter = false;

    const _keyFilter = ['pesticide_type', 'plant_type'];
    this.filterService.resetFilter(this.filterForm, _keyFilter);
    this.inputSelectMatChips?.resetOptionsTest();
  };

  onClickFilter() {
    this.isOpenFilter = !this.isOpenFilter;
  }

  handleSearch(event: string) {
    this.checkActive.next(!this.checkActive.value);
    const snapshot = this.activeRoute.snapshot;
    const dataParam = { ...snapshot.queryParams };
    if (event) {
      delete dataParam.page;
      this.router
        .navigate([], {
          queryParams: {
            ...dataParam,
            string_filter: '' || event,
          },
        })
        .then(() => null);
    } else {
      delete dataParam.string_filter;
      this.router.navigate([], { queryParams: dataParam }).then(() => null);
      this.string_filter = '';
    }
  }

  handleAction(id: string) {
    this.router.navigate(['/products/detail/' + id]);
  }

  setDataFilterValueMultiple($event: string[]) {
    this.plantTypeValue.next($event);
  }
}
